/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personsverwaltung1Inputs */

const de__field_personsverwaltung1 = /** @type {(inputs: _Field_Personsverwaltung1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person Verwaltung`)
};

/**

* @param {_Field_Personsverwaltung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personsverwaltung1 = /** @type {((inputs?: _Field_Personsverwaltung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personsverwaltung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personsverwaltung1(inputs)
});
export { _field_personsverwaltung1 as "_field_personsVerwaltung" }